import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';
import Editable from "react-x-editable";

class DownloadArtworks extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
            fetching: false,
            fetchingcsv: false
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

    componentDidUpdate() {

    }
ensureDataFetched() {
  
   
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setPropValue(id, name, _prop) {

        this.props.setProductProp(id, _prop, name.newValue);

    }


    downloadArtworksCSV(token) {

        this.setState({ fetchingcsv: true });
        var FileDownload = require("js-file-download");
        var payload = this.state.codes.split(" ");;
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${token}`);
        const url = `api/data/getReportCSV`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
        try {
            fetch(request).then(response => response.blob()).then(response => {
                FileDownload(response, "artworks.csv");
                this.setState({ fetchingcsv: false });
            }
            );

        } catch (e) {
            console.error(e);
        }
              
        const url2 = `api/data/getReportCatalogueBreakdownCSV`;
        request = new Request(url2, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
        try {
            fetch(request).then(response => response.blob()).then(response => {
                FileDownload(response, "artworks-catalogues.csv");
                this.setState({ fetchingcsv: false });
            }
            );

        } catch (e) {
            console.error(e);
        }


        const url3 = `api/data/getReportSummaryCSV`;
        request = new Request(url3, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
        try {
            fetch(request).then(response => response.blob()).then(response => {
                FileDownload(response, "artworks-summary.csv");
                this.setState({ fetchingcsv: false });
            }
            );

        } catch (e) {
            console.error(e);
        }

        //getReportSummaryCSV

        //getReportCatalogueBreakdownCSV


        //fetch("/api/data/getArworks",
        //    {
        //        method: "POST",
        //        headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + window.localStorage["Access_Token"] },
        //        body: data
        //    }).then(response => response.blob()).then(response => ...* your code for download *... )
    }



    downloadArtworks(token) {

        this.setState({ fetching: true });
        var FileDownload = require("js-file-download");
        var payload = this.state.codes.split(" ");;
        var headers = new Headers();
        headers.append('Content-type', 'application/json')
        headers.append('Authorization', `Bearer ${token}`);
        const url = `api/data/getArtworks`;
        var request = new Request(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
        try {
            fetch(request).then(response => response.blob()).then(response => {
                FileDownload(response, "artworks.zip");
                this.setState({ fetching:false });
            }         
                );
                 
        } catch (e) {
            console.error(e);
        }

        //fetch("/api/data/getArworks",
        //    {
        //        method: "POST",
        //        headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + window.localStorage["Access_Token"] },
        //        body: data
        //    }).then(response => response.blob()).then(response => ...* your code for download *... )
    }

render() {
    const access = localStorage.getItem("accessToken");
    return (
        <div>              
                <h1>Download Artworks</h1>

                <div className="row">
                <div className="col-sm-6">
                    <input type="text" className="form-control" id="shortlistISRC" placeholder={"UPCS"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>                
                <div className="col-sm-3">
                    <button disabled={this.state.codes === '' || this.state.fetching} onClick={(e) => { this.downloadArtworksCSV(access); this.downloadArtworks(access) }}>{this.state.fetching || this.state.fetchingcsv ? "wait..." : "Download"}</button></div>
            </div>

            <br />

          
         

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
           
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};

function renderReactTableProducts(data, props, main) {
    const save = (value, row, _propType) => { main.setPropValue(row, value, _propType); }

    //console.info(main.state.filtered);
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: rowInfo.original.upc === props.selectedProductForUpdate ? '#00afec' : 'white',
                    color: rowInfo.original.upc === props.selectedProductForUpdate ? 'white' : 'black',

                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {
                    columns: [
                        {

                            Header: "UPC",
                            accessor: "upc",                           
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => props.selectProductForUpdate(row.value)}> {props.upcData && props.upcData.filter(t => t.upc === row.value).length > 0 ? row.value : row.value}</span>
                        )
                        },
                        {
                            Header: "Title",
                            accessor: "name",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "name")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.name}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "Version",
                            accessor: "release_version",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "release_version")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.release_version}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "C Line",
                            accessor: "c_line_text",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "c_line_text")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.c_line_text}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "C Line Year",
                            accessor: "c_line_year",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "c_line_year")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.c_line_year}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "P Line",
                            accessor: "p_line_text",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "p_line_text")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.p_line_text}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "P Line Year",
                            accessor: "p_line_year",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "p_line_year")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.p_line_year}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },





                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={20}
            style={{
                  height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};




export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(DownloadArtworks);



// WEBPACK FOOTER //
// ./src/components/DownloadArtworks.js